import { getActiveElementBackground, getHoveredElementBackground } from '@styles/globalsStyles';
export const menuItemBaseClassNames = 'text-my-gray-10 py-2 px-3 relative flex cursor-pointer select-none items-center gap-2 rounded outline-none transition-colors bg-my-gray-100';
export const menuItemSelectedClassNames = 'data-[selected]:text-my-blue-50';
export const menuItemDisabledClassNames = 'data-[disabled]:pointer-events-none data-[disabled]:text-my-gray-60';
export const menuItemHoverActiveClassNames = 'data-[highlighted]:[background:var(--hover-bg)] data-[highlighted]:active:[background:var(--active-bg)]';
export const menuItemHoverActiveClassNamesForReactSelect = 'hover:[background:var(--hover-bg)] active:[background:var(--active-bg)]';
export const getDropdownMenuItemBgStyle = (baseBackgroundColor = 'white') => {
  const hoverBg = getHoveredElementBackground(baseBackgroundColor);
  const activeBg = getActiveElementBackground(baseBackgroundColor);
  return {
    '--hover-bg': hoverBg,
    '--active-bg': activeBg
  };
};